import { SidebarV2 } from '../components/SidebarV2/SidebarV2';
import { useAuth } from '../hooks/useAuth';
import { Outlet } from 'react-router-dom';

const ApplicationRoot = () => {
  const { user, logout } = useAuth();

  return (
    <>
      <div className="sidebar">
        <SidebarV2 user={user || null} onLogout={logout} />
      </div>

      <div className="mainContent">
        <Outlet />
      </div>
    </>
  );
};

export default ApplicationRoot;
